import { useState } from 'react'

export function usePersistentState<T>(key: string, initialValue: T) {
  const [state, setState] = useState<T>(() => {
    const persisted = localStorage.getItem(key)
    if (persisted === null || persisted === 'undefined' || persisted === 'null') {
      return initialValue
    }

    try {
      return JSON.parse(persisted) as T
    } catch (e) {
      console.warn(`Failed to parse persisted state for key "${key}":`, e)
      // Clear the invalid value
      localStorage.removeItem(key)
      return initialValue
    }
  })

  const setPersistedState = (value: T | ((value: T) => T)) => {
    setState(value)
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
      console.warn(`Failed to persist state for key "${key}":`, e)
    }
  }

  const clear = () => {
    setState(initialValue)
    localStorage.removeItem(key)
  }

  return [state, setPersistedState, clear] as const
}
